import { AlertColor, SnackbarOrigin } from '@mui/material';
import { useAppDispatch } from 'src/app/hooks';
import { reducerUpdateAlert, reducerUpdateOpenAlert } from 'src/features/alert';

interface Alert {
  message: string;
  severity: AlertColor;
  action?: React.ReactNode;
}

export const useAlert = () => {
  const dispatch = useAppDispatch();
  const handleClickAlert = (newState: Partial<SnackbarOrigin & Alert>) => {
    dispatch(
      reducerUpdateAlert({
        open: true,
        horizontal: 'center',
        vertical: 'top',
        ...newState
      })
    );
  };

  const handleCloseAlert = () => {
    dispatch(reducerUpdateOpenAlert(false));
  };
  return { handleClickAlert, handleCloseAlert };
};
